var _path, _path2;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
class IconRedoLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsxs(SVGIcon, {
      ...this.props,
      name: "IconRedo",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      bidirectional: true,
      children: [_path || (_path = _jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1273.53 53.3336L1181.04 145.821L1669.51 634.291L641.182 634.167V765.312L1669.51 765.108L1181.04 1253.71L1273.53 1346.2L1919.9 699.7L1273.53 53.3336Z",
        fill: "#273540"
      })), _path2 || (_path2 = _jsx("path", {
        d: "M641.182 765.312C378.45 772.29 142.719 987.357 142.707 1251.77C142.707 1516.19 353.51 1731.14 616.248 1738.12V1866.67C452.81 1866.67 296.089 1801.71 180.519 1686.15C64.9501 1570.58 0.000324154 1413.86 -0.00183105 1250.42C-0.00181677 1086.97 64.9482 930.258 180.519 814.687C296.09 699.117 477.74 634.167 641.182 634.167V765.312Z",
        fill: "#273540"
      }))]
    });
  }
}
IconRedoLine.glyphName = 'redo';
IconRedoLine.variant = 'Line';
IconRedoLine.displayName = 'IconRedoLine';
IconRedoLine.allowedProps = [...SVGIcon.allowedProps];
export default IconRedoLine;
export { IconRedoLine };